import React, { useEffect, useState } from 'react';
import GnbHeader from '../components/GnbHeader';
import Navigation from '../components/Navigation';
import MainSlick from '../components/MainSlick';
import '../styles/Main.css';
import PackageSlick from '../components/PackageSlick';
import { chkMobile, formatMainDate, useWindowWidth } from '../js/calculator';
import VideoSlick from '../components/VideoSlick';
import AlcFooter from '../components/AlcFooter';
import GallerySlick from '../components/GallerySlick';
import axios from 'axios';

const Main = ({ lang, bg }) => {
	const [freePopup, setFreePopup] = useState(true);
	const [second, setSecond] = useState(0);
	const [isLoading, setIsLoading] = useState(true);

	const [mainData, setMainData] = useState();

	let isMobile = chkMobile();

	const fn_methodDate = () => {
		let sum = 0;
		let loopCnt = 10000000; // 루프 수행 횟수
		const _startTime = new Date().getTime(); // 시작시간

		for (let i = 0; i < loopCnt; i++) {
			sum += i;
		}
		const _endTime = new Date().getTime(); // 종료시간
	};

	// localStorage를 활용한 캐싱
	const CACHE_KEY = 'main_data_cache';
	const CACHE_EXPIRY = 1000 * 60 * 5; // 5분

	const getMainData = async () => {
		setIsLoading(true);
		try {
			const response = await axios.get(
				`${process.env.REACT_APP_BASE_URL}/v1/main?lang=${lang === 'en' ? 'ENG' : 'KOR'}`,
			);
			setMainData(response.data);
		} catch (err) {
			// console.error(`Error fetching data: ${err}`);
			alert(`error code ${err} 관리자에게 문의하세요.`);
		} finally {
			setIsLoading(false);
		}
	};

	const [openPopup, setOpenPopup] = useState(true);

	const handleClosePopup = () => {
		// 현재 시간을 milliseconds로 저장
		const expireTime = Date.now() + 24 * 60 * 60 * 1000; // 24시간
		localStorage.setItem('packagePopExpire', expireTime.toString());

		// 팝업 닫기
		setOpenPopup(false);

		// class 추가
		const popupElement = document.getElementById('packagePop');
		if (popupElement) {
			popupElement.classList.add('close');
		}
	};

	useEffect(() => {
		const popupElement = document.getElementById('packagePop');
		if (popupElement && openPopup) {
			document.body.style.overflow = 'hidden';
		} else {
			document.body.style.overflow = 'auto';
		}
	}, [openPopup]);

	useEffect(() => {
		const checkPopupStatus = () => {
			const expireTime = localStorage.getItem('packagePopExpire');

			if (expireTime) {
				// 현재 시간과 저장된 만료 시간 비교
				if (Date.now() < parseInt(expireTime)) {
					setOpenPopup(false);
					const popupElement = document.getElementById('packagePop');
					if (popupElement) {
						popupElement.classList.add('close');
					}
				} else {
					// 만료 시간이 지났으면 localStorage 삭제
					localStorage.removeItem('packagePopExpire');
				}
			}
		};

		checkPopupStatus();
	}, []);

	useEffect(() => {
		const fetchData = async () => {
			const start = performance.now();
			await getMainData();
			const end = performance.now();
			// console.log(`Data fetching took ${end - start} milliseconds.`);
		};

		fetchData();
	}, []);

	const pdfUrl =
		lang === 'en'
			? 'https://image.chosun.com/alc/2026/alc-2026-brochure-web-eng.pdf'
			: 'https://image.chosun.com/alc/2026/alc-2026-brochure-web-kor.pdf';
	let chkIsMobile = useWindowWidth();

	const getViewerUrl = () => {
		if (chkIsMobile) {
			return `https://docs.google.com/viewer?url=${encodeURIComponent(pdfUrl)}&embedded=true`;
		}
		return pdfUrl;
	};

	return (
		<div>
			<div id="wrapper" className="main" style={{ backgroundColor: '#FFFFFF' }}>
				{/* {lang === 'en' && (
					<div id="packagePop" className="package_pop">
						<div className="inner">
							<div className="cont_wrap">
								<h1 className="popup_logo">
									<img
										src="https://image.chosun.com/alc/2026/popup-logo.svg"
										alt="AsianLeadershipConference"
									/>
								</h1>
								<h2>
									<img
										src="https://image.chosun.com/alc/2025/special-offer.png"
										alt="special offer"
									/>
								</h2>
								<div className="hotel_img">
									<img src="https://image.chosun.com/alc/2025/popup_img.png" alt="" />
								</div>
								<p className="sty1">
									Meet Asian Leadership Conference Ticket Package !<br />
									Learn, Network and Meet
									<br />
									hundreds of global leaders offline.
								</p>
								<p className="sty2">
									Venue: The Shilla Seoul
									<br />
									Date: May 20-21, 2026
								</p>
								<a className="more_btn" href="/en/package">
									<img src="https://image.chosun.com/alc/2025/more_btn.png" alt="More Details" />
								</a>
								<button
									onClick={() => {
										handleClosePopup();
									}}
									className="popup_close"
								>
									<img src="https://image.chosun.com/alc/2025/popup_btn.png" alt="close" />
								</button>
							</div>
						</div>
					</div>
				)} */}

				{/* {lang !== 'en' && (
					<div id="packagePop" className="package_pop">
						<div className="inner_kr">
							<div className="cont_wrap_kr">
								<button
									onClick={() => {
										handleClosePopup();
									}}
									className="popup_close"
								>
									<img src="https://image.chosun.com/alc/2025/popup_btn.png" alt="close" />
								</button>
								<div className="cont_wrap_kr_inner">
									<h1 className="popup_logo_kr">
										<img
											src="https://image.chosun.com/alc/2025/popup-logo.svg"
											alt="AsianLeadershipConference"
										/>
									</h1>
									<img
										className="highlight_title_text pc-view"
										src="https://image.chosun.com/alc/2025/highlight-title-1.png"
									/>
									<img
										className="highlight_title_text mobile-view"
										src="https://image.chosun.com/alc/2025/highlight-title-2.png"
									/>
									<img
										className="popup_point"
										src="https://image.chosun.com/alc/2025/pop-kr-point.png"
									/>
								</div>
								<div className="cont_wrap_kr_bottom ">
									<div className="popup-textwrapper-kr">
										<div className="popup-textbox-kr">
											<span className="left-text">기간</span>
											<span className="right-text">선착순 등록 100명 마감까지</span>
										</div>
										<div className="popup-textbox-kr-baseline">
											<span className="left-text">대상</span>
											<div className="popup-textbox-column-kr">
											<span className="right-text">일반참가자(ALC 신규 기업, 예비 창업자, 교수, 교사 등)</span>
											<span className="notice-red">* 기존 구매 내역이 있는 기업참가자의 경우 사무국으로 문의 주시기 바랍니다.</span>
											</div>
										</div>
										<div className="popup-textbox-kr no-margin-bottom">
											<span className="left-text">금액</span>
											<span className="right-text">200만원</span>
											<span className="right-text" style={{ fontSize: '16px' }}>
												&nbsp;(VAT포함)
											</span>
										</div>
										<div className="popup-textbox-kr-baseline">
											<span className="left-text">조건</span>
											<div className="popup-textbox-column-kr">
												<div className="popup-textbox-kr no-margin-bottom">
													<img
														className="right-num-img"
														src="https://image.chosun.com/alc/2025/banner-no-1.svg"
													/>
													<span className="right-text">오프라인 참석 (LIVE/VOD 시청 불가)</span>
												</div>
												<div className="popup-textbox-kr no-margin-bottom">
													<img
														className="right-num-img"
														src="https://image.chosun.com/alc/2025/banner-no-2.svg"
													/>
													<span className="right-text">무통장 입금</span>
												</div>
												<a className="email-link-kr" href="mailto:alc_reg@chosun.com">
													문의사항 :&nbsp;
													<span className="underline">alc_reg@chosun.com</span>
												</a>
											</div>
										</div>
									</div>
									<a
										href="https://board.chosun.com/nbrd/bbs/view.html?b_bbs_id=10004&pn=1&num=36&pbranch=10"
										className="detail-btn-kr"
									>
										자세히 보기
									</a>
								</div>
							</div>
						</div>
					</div>
				)} */}

				{/* <div id="packagePop" className="package_pop">
						<div className="inner_kr_end">
							<div className="cont_wrap_kr">
								<button
									onClick={() => {
										handleClosePopup();
									}}
									className="popup_close"
								>
									<img src="https://image.chosun.com/alc/2025/popup_btn.png" alt="close" />
								</button>
								<div className="img-box">
									<img src='https://image.chosun.com/alc/2025/alc-pop-end-logo.png' className='logo'/>
									{chkIsMobile ? 
									(lang === 'en' ? <span className='title font-38'>Registration for<br/>ALC 2025 <br/>is now closed</span>:<><span className='title font-36'>ALC 2025</span><span className='title font-48'>등록 마감 안내</span></>)
									:
									(lang === 'en' ? <span className='title font-38'>Registration for ALC 2025 <br/>is now closed</span>:<><span className='title font-36'>ALC 2025</span><span className='title font-48'>등록 마감 안내</span></>)
									}
								</div>
								<div className="cont_wrap_kr_text_wrapper">
									{lang === 'en' ? 
									<span className='title'>Pre-registration for ALC 2025 is now <span className='point'>closed</span>.<br/>
									<br/>Thank you for your interest, and we look forward<br/>to welcoming you at the event.
									</span>
									:
									<span className='title'>ALC 2025 사전 등록이 <span className='point'>마감</span>되었습니다.<br/>
									<br/>많은 관심 감사드리며,<br/>행사장에서 뵙기를 기대하겠습니다.
									</span>
									}
									<a
										href={lang === 'en' ? 'https://board.chosun.com/nbrd/bbs/list.html?b_bbs_id=10004&branch=20&pn=': 'https://board.chosun.com/nbrd/bbs/list.html?b_bbs_id=10004&branch=10&pn='}
										className="detail-btn-kr-end"
									>
										{lang === 'en' ? 'Check Notices':'공지사항 바로가기'}
									</a>
								</div>
							</div>
						</div>
					</div> */}
				<GnbHeader bg={bg} lang={lang} />
				<Navigation bg={bg} lang={lang} />
				<div className="container" id="container">
					<div className="visual_wrap">
						<div className="main_visual">
							<div className="visual_img">
								<MainSlick
									dots={false}
									infinite={true}
									speed={500}
									fade={true}
									cssEase={'linear'}
									autoplay={true}
									autoplaySpeed={3000}
									data={mainData?.titleImgs}
								/>
							</div>
							<div className="cont">
								<div className="visual_logo">
									<img src={mainData?.mainLogoImgUrl} alt="Asian Leadership Conference" />
								</div>
								<div className="visual_title">{mainData?.mainNm?.replace(/\\n/g, '\n')}</div>
								<div className="visual_date">
									<div className="inner">
										<em>
											{formatMainDate(mainData?.startTime, lang, 'start')} ~{' '}
											{formatMainDate(mainData?.endTime, lang, 'end')}
										</em>
										<em>{mainData?.location}</em>
									</div>
								</div>
								{lang === 'en' ? (
									<div className="visual_buttons">
										<a className="btn1" href={getViewerUrl()} target="_blank" rel="noreferrer">
											About ALC
										</a>
										<a className="btn3" href="/en/program">
											Programs
										</a>
										<a className="btn2" href="/en/register">
											Register
										</a>
									</div>
								) : (
									<div className="visual_buttons">
										<a className="btn1" href={getViewerUrl()} target="_blank" rel="noreferrer">
											ALC 소개
										</a>
										<a className="btn3" href="/program">
											프로그램
										</a>
										<a className="btn2" href="/register">
											참가 등록
										</a>
									</div>
								)}
							</div>
						</div>
					</div>

					{/* {lang === 'en' ? (
						<div className="alc_introduce">
							<img
								className="alc_introduce_bg"
								src="https://image.chosun.com/alc/2025/introduce_bg.jpg"
							/>
							<div className="alc_introduce_wrap">
								<span className="alc_main_speaker_title_web" style={{ marginTop: '0' }}>
									Asian Leadership Conference
								</span>
								<span className="alc_main_speaker_title_mobile" style={{ marginTop: '0' }}>
									Asian Leadership
									<br />
									Conference
								</span>
								<div className="alc_introduce_underbar"></div>
								<span className="alc_introduce_dec_web">
									The Asian Leadership Conference (ALC) is Korea&apos;s premier international
									conference. The
									<br />
									Chosunilbo, the largest and most trusted media institution in Korea, hosts the
									conference annually
									<br />
									to inspire younger generations and provide a platform for global leaders to gather
									and discuss the
									<br />
									most pressing issues facing the world.
									<br />
									<br />
									World - renowned political leaders, global corporate CEOs, and academic scholars
									have shared their
									<br />
									visions at past conferences, and attendees have included Korea’s biggest
									conglomerates, senior
									<br />
									governmental leaders, and academic researchers.
								</span>
								<span className="alc_introduce_dec_tab">
									The Asian Leadership Conference (ALC) is Korea&apos;s premier international
									<br />
									conference.The Chosunilbo, the largest and most trusted media
									<br />
									institution in Korea, hosts the conference annually to inspire younger
									<br />
									generations and provide a platform for global leaders to gather and
									<br />
									discuss the most pressing issues facing the world.
									<br />
									<br />
									World - renowned political leaders, global corporate CEOs, and
									<br />
									academic scholars have shared their visions at past conferences, and
									<br />
									attendees have included Korea’s biggest conglomerates, senior
									<br />
									governmental leaders, and academic researchers.
								</span>
								<span className="alc_introduce_dec_mobile">
									The Asian Leadership Conference (ALC) is Korea&apos;s premier international
									conference. The Chosunilbo, the largest and most trusted media institution in
									Korea, hosts the conference annually to inspire younger generations and provide a
									platform for global leaders to gather and discuss the most pressing issues facing
									the world.
									<br />
									<br />
									World - renowned political leaders, global corporate CEOs, and academic scholars
									have shared their visions at past conferences, and attendees have included Korea’s
									biggest conglomerates, senior governmental leaders, and academic researchers.
								</span>
								<a href="/en/about">
									<button className="alc_introduce_btn">More</button>
								</a>
							</div>
						</div>
					) : (
						<div className="alc_introduce">
							<img
								className="alc_introduce_bg"
								src="https://image.chosun.com/alc/2025/introduce_bg.jpg"
							/>
							<div className="alc_introduce_wrap">
								<img
									className="alc_introduce_text"
									src="https://image.chosun.com/alc/2024/img/INTRODUCE.svg"
								/>
								<span className="alc_main_speaker_title_web">Asian Leadership Conference</span>
								<span className="alc_main_speaker_title_mobile">
									Asian Leadership
									<br />
									Conference
								</span>
								<div className="alc_introduce_underbar"></div>
								<span className="alc_introduce_dec_web">
									조선일보가 주최하는 아시안리더십콘퍼런스(ALC)는 세계의 정치 지도자, 기업인,
									석학들이 한곳에 모여
									<br />
									현대 사회가 직면한 이슈들을 놓고 해결 방안을 모색하는 아시아 최고 수준의 국제
									행사입니다.
									<br />
									<br />
									2005년 제 1회 대회가 개최된 이래 버락 오바마 전 미국 대통령, 마윈 알리바바 그룹
									회장, 니얼 퍼거슨 하버드대
									<br />
									교수 등 저명한 글로벌 리더와 학자들이 ALC 연사로 참여했습니다.
									<br />
									<br />
									글로벌 기업의 최고위 임원들과 정부 관계자, 학자, 대학생 등 3,500명이 매년 참석하는
									ALC는
									<br />
									다양한 해법들과 함께 여러분들을 찾아갈 것입니다.
									<br />
								</span>
								<span className="alc_introduce_dec_tab">
									조선일보가 주최하는 아시안리더십콘퍼런스(ALC)는 세계의 정치 지도자, 기업인,
									<br />
									석학들이 한곳에 모여 현대 사회가 직면한 이슈들을 놓고 해결 방안을 모색하는
									<br />
									아시아 최고 수준의 국제 행사입니다.
									<br />
									<br />
									2005년 제 1회 대회가 개최된 이래 버락 오바마 전 미국 대통령, 마윈 알리바바
									<br />
									그룹 회장, 니얼 퍼거슨 하버드대 교수 등 저명한 글로벌 리더와 학자들이 ALC
									<br />
									연사로 참여했습니다.
									<br />
									<br />
									글로벌 기업의 최고위 임원들과 정부 관계자, 학자, 대학생 등 3,500명이 매년
									<br />
									참석하는 ALC는 다양한 해법들과 함께 여러분들을 찾아갈 것입니다.
									<br />
								</span>
								<span className="alc_introduce_dec_mobile">
									조선일보가 주최하는 아시안리더십콘퍼런스 (ALC)는 세계의 정치 지도자, 기업인,
									석학들이 한곳에 모여 현대 사회가 직면한 이슈들을 놓고 해결 방안을 모색하는 아시아
									최고 수준의 국제 행사입니다.
									<br />
									<br />
									2005년 제 1회 대회가 개최된 이래 버락 오바마 전 미국 대통령, 마윈 알리바바 그룹
									회장, 니얼 퍼거슨 하버드대 교수 등 저명한 글로벌 리더와 학자들이 ALC 연사로
									참여했습니다.
									<br />
									<br />
									글로벌 기업의 최고위 임원들과 정부 관계자, 학자, 대학생 등 3,500명이 매년 참석하는
									ALC는 다양한 해법들과 함께 여러분들을 찾아갈 것입니다.
								</span>
								<a href="/about">
									<button className="alc_introduce_btn">ALC 소개 더보기</button>
								</a>
							</div>
						</div>
					)} */}

					{/* {lang === 'en' ? (
						<div className="alc_register_en_main">
							<img
								className={isMobile ? 'alc_register_img_web_main_2' : 'alc_register_img_web_main'}
								id="alc_register_img_web"
								src="https://image.chosun.com/alc/2025/register_bg_L.jpg"
							/>
							<img
								className={
									isMobile ? 'alc_register_img_mobile_en_main' : 'alc_register_img_mobile_en_main_2'
								}
								src="https://image.chosun.com/alc/2025/register_bg_S.jpg"
							/>
							<div className="alc_register_wrap_main">
								<span className="alc_register_title_main" style={{ marginTop: '0' }}>
									Register for ALC
								</span>
								<span className="alc_register_dec_web_main" id="alc_register_dec_web">
									Register for the 2026 Asian Leadership Conference and watch the lectures through
									the website.
									<br />
									After registering as a member of Chosun Media, you can purchase ALC tickets or
									enter the invitation code.
								</span>
								{isMobile ? (
									<span className="alc_register_dec_tab_main" id="alc_register_dec_tab">
										Register is only available on PC
									</span>
								) : (
									<span className="alc_register_dec_tab_main" id="alc_register_dec_tab">
										Register for the 2026 Asian Leadership Conference and watch the lectures
										<br />
										through the website. After registering as a member of Chosun Media,
										<br />
										you can purchase ALC tickets or enter the invitation code.
									</span>
								)}
								{isMobile ? (
									<span className="alc_register_dec_mobile_main" id="alc_register_dec_mobile">
										Register is only available on PC
									</span>
								) : (
									<span className="alc_register_dec_mobile_main" id="alc_register_dec_mobile">
										Register for the 2026 Asian Leadership
										<br />
										Conference and watch the lectures through
										<br />
										the website.
										<br />
										After registering as a member of Chosun
										<br />
										Media, you can purchase ALC tickets or enter
										<br />
										the invitation code.
									</span>
								)}
								{!isMobile && (
									<a href="/en/register">
										<button className="alc_register_btn_main" id="alc_register_btn">
											Register
										</button>
									</a>
								)}
							</div>
						</div>
					) : (
						<div className="alc_register_main">
							<img
								className={isMobile ? 'alc_register_img_web_main_2' : 'alc_register_img_web_main'}
								id="alc_register_img_web"
								src="https://image.chosun.com/alc/2025/register_bg_L.jpg"
							/>
							<img
								className={
									isMobile ? 'alc_register_img_mobile_main' : 'alc_register_img_mobile_main_2'
								}
								id="alc_register_img_web"
								src="https://image.chosun.com/alc/2025/register_bg_S.jpg"
							/>
							<div className="alc_register_wrap_main">
								<img src="https://image.chosun.com/alc/2024/img/register_title.svg" />
								<span className="alc_register_title_main">참가 등록</span>
								<span className="alc_register_dec_web_main" id="alc_register_dec_web">
									2026 아시안리더십콘퍼런스에 참가등록을 하고, 연사들의 강연을 만나보십시오.
									<br />
									조선미디어 회원가입 후 ALC 입장권을 구매하거나 초청코드를 등록할 수 있습니다.
								</span>
								{isMobile ? (
									<span className="alc_register_dec_tab_main" id="alc_register_dec_tab">
										참가등록 신청은 PC에서만 가능합니다.
									</span>
								) : (
									<span className="alc_register_dec_tab_main" id="alc_register_dec_tab">
										2026 아시안리더십콘퍼런스에 참가등록을 하고, 연사들의 강연을 만나보십시오.
										<br />
										조선미디어 회원가입 후 ALC 입장권을 구매하거나 초청코드를 등록할 수 있습니다.
									</span>
								)}

								<span className="alc_register_dec_mobile_main" id="alc_register_dec_mobile">
									{isMobile ? (
										<span className="alc_register_dec_mobile_main" id="alc_register_dec_mobile">
											참가등록 신청은 PC에서만 가능합니다.
										</span>
									) : (
										<span className="alc_register_dec_mobile_main" id="alc_register_dec_mobile">
											2026 아시안리더십콘퍼런스에 참가등록을 하고,
											<br />
											연사들의 강연을 만나보십시오.
											<br />
											조선미디어 회원가입 후 ALC 입장권을 구매하거나
											<br />
											초청코드를 등록할 수 있습니다
										</span>
									)}
								</span>
								{!isMobile && (
									<a href="/register">
										<button className="alc_register_btn_main" id="alc_register_btn">
											참가 등록하기
										</button>
									</a>
								)}
							</div>
						</div>
					)} */}

					<div className="speaker_section">
						<div className="speaker_section_img">
							<img src="https://image.chosun.com/alc/2025/speaker_alc_title.svg" alt="speaker" />
						</div>
						{lang === 'en' ? <h1>2026 Key Speakers</h1> : <h1>2026 주요 초청연사</h1>}
						<div className="s_slide">
							<PackageSlick
								dots={false}
								infinite={false}
								speed={300}
								slidesToShow={4}
								slidesToScroll={4}
								tabletSlidesToShow={3.5}
								tabletSlidesToScroll={1}
								mobileSlidesToShow={1.6}
								mobileSlidesToScroll={1}
								lang={lang}
							/>
						</div>
						{lang === 'en' ? (
							<a href="/en/speaker" className="more_btn">
								<span>More</span>
							</a>
						) : (
							<a href="/speaker" className="more_btn">
								<span>연사 더보기</span>
							</a>
						)}
					</div>

					<div className="main_video_slide">
						<div className="cont_title">
							<div className="eng_icon">
								<img src="https://image.chosun.com/alc/2025/video-title.png" alt="speaker" />
							</div>
							<h1>
								{lang === 'en' ? (
									<a href="/en/video">Video Highlight</a>
								) : (
									<a href="/video">영상 하이라이트</a>
								)}
							</h1>
						</div>
						<div className="video_slider">
							<VideoSlick
								lang={lang}
								dots={true}
								infinite={false}
								speed={300}
								slidesToShow={1}
								slidesToScroll={1}
								tabletSlidesToShow={1}
								tabletSlidesToScroll={1}
								mobileSlidesToShow={1}
								mobileSlidesToScroll={1}
								autoplay={false}
								autoplaySpeed={2000}
								galleryData={mainData?.displays}
								key={JSON.stringify(mainData?.displays)}
							/>
						</div>
					</div>

					<div className="highlight" style={{ backgroundColor: '#F7F7F7' }}>
						<div className="cont_title">
							<div className="eng_icon">
								<img src="https://image.chosun.com/alc/2025/gallery-title.png" alt="gallery" />
							</div>
							<h1>
								{lang === 'en' ? (
									<a href="/en/gallery">Gallery Highlight</a>
								) : (
									<a href="/gallery">갤러리 하이라이트</a>
								)}
							</h1>
						</div>
						{/* <div className="slider-container"> */}
						<div className="h_slider slick-initialized slick-slider slick-dotted">
							<GallerySlick
								lang={lang}
								centerMode={true}
								centerPadding={'31%'}
								adaptiveHeight={true}
								dots={true}
								autoplay={true}
								autoplaySpeed={10000}
								slidesToShow={1}
								slidesToScroll={1}
								infinite={true}
							/>
						</div>
					</div>

					{/* <div className='news_letter'>
            <div className='inner'>
              <div className='news_letter_img'><img src='https://alc.chosun.com/2023/img/newsletter.png' alt='newsletter' />
              </div>
              <div className='txt1'>2023 ALC 뉴스레터 신청</div>
              <div className='txt2'>2023 ALC 관련 소식을 빠르게 받고 싶다면?</div>
              <a className='btn' href='https://page.stibee.com/subscriptions/184104'>신청하기</a>
            </div>
          </div> */}
				</div>
				{/* <!-- container end --> */}
				<AlcFooter lang={lang} bg={bg} />
			</div>
		</div>
	);
};

export default Main;
